import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private KEY_USER_ID = 'userId';
  private KEY_USER_NAME = 'userName';
  private KEY_HOSPITAL_CODE = 'hospitalCode';
  private KEY_HOSPITAL_NAME = 'hospitalName';
  private KEY_ACCESS_TOKEN = 'accessToken';
  private KEY_ID_TOKEN = 'idToken';
  private KEY_APPLICATION_CLIENT_ID = 'applicationClientId';
  private KEY_REFRESH_TOKEN = 'refreshToken';
  private KEY_POSITION_DATA_TYPE = 'scrollPosition:data-types';
  private KEY_SELECTED_REVIEW_ID = 'reviews:selectedId';
  private KEY_ADMIN_SELECTED_REVIEW_ID = 'admin-reviews:selectedId';
  private KEY_TARGET_HOSPITAL_CODE = 'targetHospitalCode';
  private KEY_TARGET_HOSPITAL_NAME = 'targetHospitalName';
  private KEY_FROM_ADMIN = 'fromAdmin';

  public saveUserName(userName: string) {
    sessionStorage.setItem(this.KEY_USER_NAME, userName);
  }

  public saveHospitalName(hospitalName: string) {
    sessionStorage.setItem(this.KEY_HOSPITAL_NAME, hospitalName);
  }

  public saveAccessToken(accessToken: string) {
    sessionStorage.setItem(this.KEY_ACCESS_TOKEN, accessToken);
  }

  public saveIdToken(idToken: string) {
    sessionStorage.setItem(this.KEY_ID_TOKEN, idToken);
  }

  public savePositionDataType(position: string) {
    sessionStorage.setItem(this.KEY_POSITION_DATA_TYPE, position);
  }

  public saveSelectedReviewId(id: string) {
    sessionStorage.setItem(this.KEY_SELECTED_REVIEW_ID, id);
  }

  public saveAdminSelectedReviewId(id: string) {
    sessionStorage.setItem(this.KEY_ADMIN_SELECTED_REVIEW_ID, id);
  }

  public saveTargetHospitalCode(hospitalCode: string) {
    sessionStorage.setItem(this.KEY_TARGET_HOSPITAL_CODE, hospitalCode);
  }

  public saveTargetHospitalName(hospitalName: string) {
    sessionStorage.setItem(this.KEY_TARGET_HOSPITAL_NAME, hospitalName);
  }

  public saveFromAdmin(fromAdmin: string) {
    sessionStorage.setItem(this.KEY_FROM_ADMIN, fromAdmin);
  }

  public saveAuthToken(
    applicationClientId: string,
    accessToken: string,
    idToken: string,
    refreshToken: string,
    hospitalCode: string,
    userId: string,
    userName: string,
  ) {
    sessionStorage.setItem(this.KEY_APPLICATION_CLIENT_ID, applicationClientId);
    sessionStorage.setItem(this.KEY_ACCESS_TOKEN, accessToken);
    sessionStorage.setItem(this.KEY_ID_TOKEN, idToken);
    sessionStorage.setItem(this.KEY_REFRESH_TOKEN, refreshToken);
    sessionStorage.setItem(this.KEY_HOSPITAL_CODE, hospitalCode);
    sessionStorage.setItem(this.KEY_USER_ID, userId);
    sessionStorage.setItem(this.KEY_USER_NAME, userName);
  }

  public hasAuthToken(): boolean {
    return (
      sessionStorage.getItem(this.KEY_APPLICATION_CLIENT_ID) !== null &&
      sessionStorage.getItem(this.KEY_ACCESS_TOKEN) !== null &&
      sessionStorage.getItem(this.KEY_ID_TOKEN) !== null &&
      sessionStorage.getItem(this.KEY_REFRESH_TOKEN) !== null
    );
  }

  /**
   * ログアウト時にSessionStorageの内容をすべて削除
   */
  public logout(): void {
    sessionStorage.clear();
  }

  public getUserName(): string | null {
    const userName = sessionStorage.getItem(this.KEY_USER_NAME);
    return userName;
  }

  public getApplicationClientId(): string | null {
    const applicationClientId = sessionStorage.getItem(
      this.KEY_APPLICATION_CLIENT_ID,
    );
    return applicationClientId;
  }

  public getRefreshToken(): string | null {
    const refreshtoken = sessionStorage.getItem(this.KEY_REFRESH_TOKEN);
    return refreshtoken;
  }

  public getHospitalCode(): string | null {
    const hospitalCode = sessionStorage.getItem(this.KEY_HOSPITAL_CODE);
    return hospitalCode;
  }

  public getAccessToken(): string | null {
    const accessToken = sessionStorage.getItem(this.KEY_ACCESS_TOKEN);
    return accessToken;
  }

  public getIdToken(): string | null {
    const idToken = sessionStorage.getItem(this.KEY_ID_TOKEN);
    return idToken;
  }

  public getUserId(): string | null {
    const userId = sessionStorage.getItem(this.KEY_USER_ID);
    return userId;
  }

  public getHospitalName(): string | null {
    const hospitalName = sessionStorage.getItem(this.KEY_HOSPITAL_NAME);
    return hospitalName;
  }

  public getPositionDataType(): string | null {
    return sessionStorage.getItem(this.KEY_POSITION_DATA_TYPE);
  }

  public getSelectedReviewId(): string | null {
    return sessionStorage.getItem(this.KEY_SELECTED_REVIEW_ID);
  }

  public getAdminSelectedReviewId(): string | null {
    return sessionStorage.getItem(this.KEY_ADMIN_SELECTED_REVIEW_ID);
  }

  public getTargetHospitalCode(): string | null {
    return sessionStorage.getItem(this.KEY_TARGET_HOSPITAL_CODE);
  }

  public getTargetHospitalName(): string | null {
    return sessionStorage.getItem(this.KEY_TARGET_HOSPITAL_NAME);
  }

  public getFromAdmin(): string | null {
    return sessionStorage.getItem(this.KEY_FROM_ADMIN);
  }

  public removePositionDataType() {
    sessionStorage.removeItem(this.KEY_POSITION_DATA_TYPE);
  }

  public removeSelectedReviewId() {
    sessionStorage.removeItem(this.KEY_SELECTED_REVIEW_ID);
  }

  public removeAdminSelectedReviewId() {
    sessionStorage.removeItem(this.KEY_ADMIN_SELECTED_REVIEW_ID);
  }

  public removeTargetHospitalCode() {
    return sessionStorage.removeItem(this.KEY_TARGET_HOSPITAL_CODE);
  }

  public removeTargetHospitalName() {
    return sessionStorage.removeItem(this.KEY_TARGET_HOSPITAL_NAME);
  }

  public removeFromAdmin() {
    return sessionStorage.removeItem(this.KEY_FROM_ADMIN);
  }
}
